import theme from '../../theme/theme';

const {
  colors: { any_button, black_text, white_text, box_shadow, subtitle, divider },
} = theme;

const styles = {
  container: {
    flexDirection: 'column',
    overflowX: 'auto',
    paddingRight: '.2em',
    paddingTop: '1.125em',
    paddingBottom: '.5em',
  },

  title: {
    color: black_text,
    fontSize: '1.250em',
    fontWeight: 'normal',
    letterSpacing: '-0.031em',
    paddingLeft: '0.563em',
    paddingBottom: '1em',
  },

  scroll__wheel: {
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    display: 'block',
    paddingBottom: '.5em',
    paddingRight: '1.9em',
  },

  any__button: {
    boxShadow: `0 0.250em .5em 0 ${box_shadow}`,
    backgroundColor: `${any_button} !important`,
    borderRadius: '0.2em',
    height: '4em',
    width: '9.3em',
    textTransform: 'capitalize',
    padding: 0,
  },

  price__button: {
    borderRadius: 0,
    textTransform: 'capitalize',
    height: '4em',
    width: '9.3em',
    padding: 0,
    color: subtitle,
    borderRight: `0.063em solid ${divider}`,
  },

  any__text: {
    fontSize: '1.825em',
    color: white_text,
  },

  price__text: {
    fontSize: '1.825em',
    color: subtitle,
  },
};

export default styles;
